<div>
  <div class="buttons-over-form mb-3">
    <app-back-button></app-back-button>
  </div>
  <app-user-form-detail [data]="data"></app-user-form-detail>
</div>
